export var H4 = {
  lg: '16px',
  sm: '12px',
  xs: '8px'
};